import React from "react";
import classes from "./PrivacyPolicy.module.scss";
import noise from "../../media/noise.png";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <main>
      <section
        className={`section--1 ${classes["heading-section"]}`}
        id="nav-dark"
      >
        <div className="circle circle--4"></div>
        <div className="circle circle--3"></div>
        <div className="circle circle--2"></div>
        <div className="circle circle--1"></div>
        <img src={noise} alt={"noise background"} className="noise" />

        <div className={classes.container}>
          <div className={classes.text}>
            <span>{t('privacy.title')}</span>
            <span>{t('privacy.title2')}</span>
          </div>
        </div>
      </section>

      <section className="section--white" id="nav-dark">
        <div className={classes.container}>
          <p>{t('privacy.date')}</p>
          <div className={classes.content}>
            <div className={classes.heading}>
              <h2 className={classes.header}>
                {t('privacy.textTitle')}{" "}
              </h2>
              <p>
                {t('privacy.text')}{" "}
                <a href="https://go-te.co/">https://go-te.co/</a>
              </p>
            </div>

            <div className={classes.body}>
              <div className={classes.block}>
                <h4 className={classes.title}>{t('privacy.textTitle2')}</h4>
                <p className={classes.text}>
                  {t('privacy.text2')}
                </p>
              </div>
              <div className={classes.block}>
                <h4 className={classes.title}>{t('privacy.textTitle3')}</h4>
                <p className={classes.text}>
                  {t('privacy.text3')}
                </p>
              </div>

              <div className={classes.block}>
                <h4 className={classes.title}>{t('privacy.textTitle4')}</h4>
                <p className={classes.text}>
                  {t('privacy.text4')}</p>
              </div>

              <div className={classes.block}>
                <h4 className={classes.title}>{t('privacy.textTitle5')}</h4>
                <p className={classes.text}>{t('privacy.text5')}
                </p>
              </div>

              <div className={classes.block}>
                <h4 className={classes.title}>{t('privacy.textTitle6')}</h4>
                <p className={classes.text}>{t('privacy.text6')}
                </p>
              </div>
            </div>
          </div>
          <p>
            {t('privacy.text7')} <a href="mailto:contact@go-te.co">[contact@go-te.co]</a>
          </p>
        <p>{t('privacy.text8')}</p>
        </div>

      </section>
    </main>
  );
};

export default PrivacyPolicy;
